import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapComponent } from './field-editor-map.component';
import {
  DxButtonGroupModule,
  DxFormModule,
  DxLoadPanelModule,
  DxPopoverModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxSpeedDialActionModule
} from 'devextreme-angular';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { FieldEditorMapViewSelectorModule } from '../field-editor-map-view-selector/field-editor-map-view-selector.module';
import { FieldEditorMapEditControlModule } from '../field-editor-map-edit-control/field-editor-map-edit-control.module';
import { FieldFormModule } from '../field-form/field-form.module';
import { FieldEditorUnsavedChangesModule } from '../field-editor-unsaved-changes/field-editor-unsaved-changes.module';
import { MapLayersControlModule } from '../../map/map-layers-control/map-layers-control.module';
import { UserDomainsChooserModule } from '../../user-domains/user-domains-chooser/user-domains-chooser.module';
import { FieldEditorMapFieldCropControlModule } from '../field-editor-map-field-crop-control/field-editor-map-field-crop-control.module';
import { CampaignSelectorModule } from '../../campaign/campaign-selector/campaign-selector.module';



@NgModule({
  declarations: [FieldEditorMapComponent],
  imports: [
    CommonModule,
    DxLoadPanelModule,
    LeafletModule,
    DxPopupModule,
    FieldEditorMapViewSelectorModule,
    FieldEditorMapEditControlModule,
    FieldFormModule,
    FieldEditorUnsavedChangesModule,
    DxSpeedDialActionModule,
    MapLayersControlModule,
    DxPopoverModule,
    DxFormModule,
    UserDomainsChooserModule,
    DxButtonGroupModule,
    FieldEditorMapFieldCropControlModule,
    DxSelectBoxModule,
    CampaignSelectorModule
  ],
  exports: [FieldEditorMapComponent]
})
export class FieldEditorMapModule { }
